import { createReducer } from "@reduxjs/toolkit";
import type { UploadState } from "@redux/state/shared-types";
import { resetUploadProfilePicture, uploadProfilePicture, uploadProfilePicturePublic } from "./upload-profile-picture";

const initialState: UploadState = { processing: "idle", url: null };

export const uploadProfilePictureReducer = createReducer<UploadState>(initialState, builder => {
  builder.addCase(uploadProfilePicture.fulfilled, (state, { payload }) => {
    return { ...state, url: payload, processing: "success" };
  });
  builder.addCase(uploadProfilePicture.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(uploadProfilePicture.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(uploadProfilePicturePublic.fulfilled, (state, { payload }) => {
    return { ...state, url: payload, processing: "success" };
  });
  builder.addCase(uploadProfilePicturePublic.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(uploadProfilePicturePublic.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetUploadProfilePicture, () => {
    return initialState;
  });
});
